<div class="notes-container">
  <div *ngIf="!hideHeader" class="notes-card-header tw-flex tw-flex-col tw-pt-2">
    <div class="tw-flex tw-items-center tw-justify-between {{!hideHeader ? 'tw-px-4' : ''}}">
      <div>
        <span *ngIf="useDealNotes else borrowerNotes">
          <a [routerLink]="['/borrower/' + borrowerId]" class="tw-text-lg">{{ borrowerName }}</a>
          <h2 class="!tw-mb-0">Deal Notes</h2>
        </span>

        <ng-template #borrowerNotes>
          <h2 class="!tw-mb-0">Borrower Notes</h2>
        </ng-template>
      </div>
      <button
        mat-flat-button
        [color]="'primary'"
        (click)="expandStatus === false ? addNotePanel.open() : addNotePanel.close()"
        class="notes-button"
        data-cy="add-note-button">{{ expandStatus === false ? 'Add Note' : 'Cancel' }}
      </button>
    </div>
  </div>
  <mat-expansion-panel
    #addNotePanel
    class="mat-elevation-z0 tw-pt-2"
    [class]="hideHeader ? 'tw-my-5' : ''"
    [hidden]="!expandStatus"
    hideToggle="true"
    [(expanded)]="expandStatus"
    (afterExpand)="handleAfterExpand()"
    (afterCollapse)="handleAfterCollapse()">
    <form [formGroup]="noteForm" [class]="hideHeader ? 'tw-mt-5' : ''">
      <mat-form-field class="add-note-textarea">
        <mat-label>Add A Note</mat-label>
        <textarea data-cy="add-note-textarea" #contentTextArea matInput formControlName="content" class="note-input"></textarea>
        <mat-error *ngIf="content.invalid && content.touched" class="has-text-danger">Note content can't be empty.</mat-error>
      </mat-form-field>
      <mat-grid-list cols="1" rowHeight="40px">
        <mat-grid-tile>
          <button
            mat-flat-button
            class="grid-align-right"
            (click)="handleAddNote()"
            [disabled]="noteForm.invalid"
            [color]="'primary'"
            data-cy="save-note-button">
            Post
          </button>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
  </mat-expansion-panel>
  <mat-divider *ngIf="expandStatus"></mat-divider>
  <div class="notes-card-content {{inContainer ? 'limit-height' : ''}}"
       [ngClass]="useDealNotes ? 'deal-notes-list' : 'notes-list'">
    <div *ngFor="let note of borrowerNotes; let i=index">
      <div *ngIf="editNoteId === note.id; else noteItem" class="note">
        <form [formGroup]="editNoteForm">
          <mat-form-field class="add-note-textarea">
            <mat-label>Editing</mat-label>
            <textarea
              matInput
              placeholder="Edit Note"
              formControlName="content"
              class="note-input"
              data-cy="edit-note-textarea">
            </textarea>
          </mat-form-field>
          <div>
            <a data-cy="save-note-link" (click)="handleEditNote(note.id)" class="edit-option">Save</a>
            <a data-cy="delete-note-link" (click)="handleDeleteNote(note.id)" class="edit-option">Delete</a>
            <a (click)="cancelEdit()" class="edit-option">Cancel</a>
          </div>
        </form>
      </div>
      <ng-template #noteItem>
        <div class="note">
          <div>
            <strong>{{ note.lenderUserName | titlecase }}</strong>
            <!-- <small><em class="mdc-typography--caption note-date">{{ note.createdTimestamp * 1000 | date: 'MM/dd/yyyy - h:mm a' }}</em></small> -->
            <small><i class="mdc-typography--caption note-date">{{ getTimestamp(note.created) | date: 'MM/dd/yyyy - h:mm a' }}</i></small>
          </div>
          <div>
            <p data-cy="note-content" [innerHTML]="note.content | newlines"></p>
            <a interactive attr.data-cy="edit-note-link-{{i}}" *ngIf="note.lenderUserId === lenderUserId" (click)="enterEditMode(note)">Edit</a>
          </div>
        </div>
      </ng-template>
      <div class="divider"></div>
    </div>
  </div>
</div>
